// Small runtime helper to detect mobile-like viewports.
// This file is safe to import from non-React modules (like api clients).
export default function isMobile(breakpoint = 768) {
  try {
    if (typeof window === 'undefined') return false;
    return window.innerWidth <= breakpoint;
  } catch (e) {
    return false;
  }
}
